import React from 'react';

import Heading from 'grommet/components/Heading';
import Spinning from 'grommet/components/icons/Spinning';

import classes from './Title.module.scss';

const Title = (props) => {
  let subHeader = null;
  if (props.subHeader) {
    subHeader = (
      <Heading tag="h4" strong={true}>
        {props.subHeader}
      </Heading>
    );
  }

  let header = <Spinning />;
  if (props.header) {
    header = <Heading>{props.header}</Heading>;
  }

  return (
    <div className={classes.headerBox} data-cy="headerBox">
      {header}
      {subHeader}
    </div>
  );
};
export default Title;
